<aside class="menu"><!--p.menu-label My content
ul.menu-list
   li( v-for="ds in ['one','two','three','four']" )
      a {{ds}}
p.menu-label Organisation--></aside>